import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
    selector: 'app-announcement-banner',
    templateUrl: './announcement-banner.component.html',
    styleUrls: ['./announcement-banner.component.scss'],
})
export class AnnouncementBannerComponent {
    @Input() messageLocalizationKey: string = undefined;
    @Input() buttonLocalizationKey: string = undefined;
    @Input() message: string = undefined;
    @Input() linkUrl: string = undefined;
    @Input() linkName: string = undefined;
    @Input() dismissible: boolean = false;

    @Output() confirm = new EventEmitter<void>();
    @Output() dismiss = new EventEmitter<void>();

    // –– bind the native `hidden` attribute on the host
    @HostBinding('attr.hidden') get hidden() {
        return !this.isVisible ? '' : null;
    }

    onConfirm() {
        this.confirm.emit();
    }

    onDismiss() {
        this.dismiss.emit();
    }

    get isVisible(): boolean {
        return this.messageLocalizationKey !== undefined || this.message !== undefined;
    }

    get hasButton(): boolean {
        return this.buttonLocalizationKey !== undefined;
    }

    get hasLink(): boolean {
        return this.linkUrl !== undefined && this.linkUrl.trim() !== '';
    }

    get displayMessage(): string {
        return this.message || '';
    }

    get linkDisplayText(): string {
        // If linkName exists and is not empty, use it; otherwise fall back to linkUrl
        return (this.linkName && this.linkName.trim() !== '') ? this.linkName : this.linkUrl;
    }
}
